import { Grid } from '@mui/material';
import { OutlineButton, Text, Colors } from 'library';
import ErrorIcon from '@mui/icons-material/Error';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ShiftProviderUser } from 'models';
import React, { useState } from 'react';
import ComplianceActionInfoModal from './ComplianceActionInfoModal';

export default function ComplianceHoldActions({
    needs_center_action,
    business_location_id,
    refresh,
    provider_user,
}: {
    provider_user: ShiftProviderUser;
    business_location_id: number;
    refresh: () => void;
    needs_center_action: string[];
}) {
    const [modalOpen, setModalOpen] = useState(false);
    const initiateAgencyReviewRequired = needs_center_action.includes('initiate_agency_review');
    const initiateResubmissionRequired = needs_center_action.includes('initiate_resubmission');

    if (!initiateAgencyReviewRequired && !initiateResubmissionRequired) return null;
    const actionText = initiateAgencyReviewRequired ? 'Initiate Agency Review' : 'Complete Resubmission';

    return (
        <>
            <OutlineButton
                boldText={false}
                onClick={() => setModalOpen(true)}
                textStyle={{ textAlign: 'left', lineHeight: 10 }}
                buttonStyle={{
                    padding: '0 2px',
                    backgroundColor: Colors.lightRed,
                }}
            >
                <Grid item container direction="row" style={{ alignItems: 'center', justifyContent: 'space-between' }}>
                    <Grid item container xs={2} style={{ justifyContent: 'center' }}>
                        <ErrorIcon style={{ color: Colors.error }} />
                    </Grid>
                    <Grid item container xs={8} justifyContent="center">
                        <Grid item xs={12}>
                            <Text bold variant="caption">
                                Action Needed:
                            </Text>
                        </Grid>
                        <Grid item xs={12}>
                            <Text variant="caption">{actionText}</Text>
                        </Grid>
                    </Grid>
                    <Grid container xs={2} justifyContent="flex-start">
                        <ChevronRightIcon style={{ padding: 0, color: Colors.darkNavy }} />
                    </Grid>
                </Grid>
            </OutlineButton>
            <ComplianceActionInfoModal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                actionText={actionText}
                provider_user={provider_user}
                business_location_id={business_location_id}
                refresh={refresh}
            />
        </>
    );
}
